/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createRangeNode } from '../../factoriesAny.js';
export var RangeNodeDependencies = {
  NodeDependencies,
  createRangeNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRangeNode.generated.js
// module id = 558
// module chunks = 2